/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type SwapMutationVariables = Types.Exact<{
	input: Types.SwapRequest;
}>;

export type SwapMutation = {
	__typename?: "Mutation";
	swap:
		| {
				__typename?: "SwapInProgressResponse";
				swapInProgress?: { __typename?: "SwapInProgress"; swapId: string } | null;
		  }
		| {
				__typename?: "SwapSuccessResponse";
				swap: {
					__typename?: "Swap";
					swapId: string;
					sourceTrade: {
						__typename?: "SwapTrade";
						tradeId: string;
						assetId: string;
						wallet: { __typename?: "Wallet"; id: string };
						amountAsset: { __typename?: "CurrencyAmount"; value: string };
						executionTime: { __typename?: "DateTime"; iso8601: string };
						fiatWalletTransaction?: { __typename?: "FiatWalletTransaction"; id: string } | null;
						fiatWallet?: { __typename?: "Wallet"; id: string } | null;
					};
					targetTrade: {
						__typename?: "SwapTrade";
						tradeId: string;
						assetId: string;
						wallet: { __typename?: "Wallet"; id: string };
						amountAsset: { __typename?: "CurrencyAmount"; value: string };
						executionTime: { __typename?: "DateTime"; iso8601: string };
					};
					taxWithheld?: {
						__typename?: "Tax";
						isTaxServiceAvailable: boolean;
						fiatId: string;
						assetId?: string | null;
						taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
						fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
						taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
					} | null;
				};
		  };
};

export const SwapDocument = gql`
	mutation swap($input: SwapRequest!) {
		swap(request: $input) {
			... on SwapSuccessResponse {
				swap {
					swapId
					sourceTrade {
						tradeId
						assetId
						wallet {
							id
						}
						amountAsset {
							value
						}
						executionTime {
							iso8601
						}
						fiatWalletTransaction {
							id
						}
						fiatWallet {
							id
						}
					}
					targetTrade {
						tradeId
						assetId
						wallet {
							id
						}
						amountAsset {
							value
						}
						executionTime {
							iso8601
						}
					}
					taxWithheld {
						taxAmountFiat {
							value
						}
						isTaxServiceAvailable
						fiatId
						assetId
						fiatAmountAfterTax {
							value
						}
						taxAmountAsset {
							value
						}
					}
				}
			}
			... on SwapInProgressResponse {
				swapInProgress {
					swapId
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class SwapGQLService extends Apollo.Mutation<SwapMutation, SwapMutationVariables> {
	document = SwapDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
